import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { jsonApiStructure } from '@app/functions';
import { Model } from '@app/models/core/base.model';
import { DocumentAssignment } from '@app/models/documents/document-assignment.model';
import { SignatureRequest } from '@app/models/documents/signature-request.model';
import { Employee } from '@app/models/employee/employee.model';
import { SlotAssignment } from '@app/modules/documents-v2/classes';

@Injectable({
    providedIn: 'root',
})
export class DocumentAssignmentService {
    constructor(private httpClient: HttpClient) {}
    /**
     * hasDuplicateSlotAssignments checks for slots having the same employee assigned
     * It ignores empty slots.
     */
    hasDuplicateSlotAssignments(documentAssignment: DocumentAssignment): boolean {
        const ids = documentAssignment.slotAssignments
            .filter((slot) => slot.employee)
            .map((slot: SlotAssignment) => slot.employee.id);

        return new Set(ids).size !== ids.length;
    }

    updateSlotAssignments(documentAssignment: DocumentAssignment): Promise<Model>[] {
        return documentAssignment.slotAssignments.map(({ slot }) =>
            slot.param('signingTemplate', slot.signingTemplateId).save()
        );
    }

    createSignatureRequests(documentAssignment: DocumentAssignment, isOnboarding?: boolean): Promise<unknown> {
        const attributes = {
            signerSlots: documentAssignment.slotAssignments.map((sa) => sa.toPayload()),
            isOnboarding: isOnboarding,
        };
        const signerSlotAssignmentsPayload = jsonApiStructure('signingTemplates', attributes);
        const url = `/v2/signingTemplates/${documentAssignment.getSigningTemplate().id}/createSignatureRequests`;

        return this.httpClient.post(url, signerSlotAssignmentsPayload).toPromise();
    }

    createSignatureRequestForEditedRequest(
        documentAssignment: DocumentAssignment,
        employee: Employee
    ): Promise<unknown> {
        return new SignatureRequest({
            employeeId: employee.id,
            requestId: documentAssignment.editedSignatureRequestId,
            // Preview is only supported during Onboarding, Mark Signature as 'is_onboarding'
            isOnboarding: true,
        })
            .param('signingTemplate', documentAssignment.companyDocument.signingTemplate.id)
            .save();
    }

    attachDocumentAcknowledgements(documentAcknowledgementAssignments: DocumentAssignment[], employee: Employee): void {
        documentAcknowledgementAssignments.forEach((d) => d.companyDocument.attach('employees', employee.id).save());
    }
}
